import {
  CreateExtractCssFromPropsParams,
  StyledPropType,
} from 'style-utils/core/core.types';
import { createExtractCssFromProps } from 'style-utils/core/createExtractCssFromProps/createExtractCssFromProps';

const defaults = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
};

const paddingMappedProperties: CreateExtractCssFromPropsParams = {
  padding: {
    property: 'padding',
    defaultScale: defaults.space,
  },
  paddingTop: {
    property: 'paddingTop',
    defaultScale: defaults.space,
  },
  paddingRight: {
    property: 'paddingRight',
    defaultScale: defaults.space,
  },
  paddingBottom: {
    property: 'paddingBottom',
    defaultScale: defaults.space,
  },
  paddingLeft: {
    property: 'paddingLeft',
    defaultScale: defaults.space,
  },
  paddingX: {
    properties: ['paddingLeft', 'paddingRight'],
    defaultScale: defaults.space,
  },
  paddingY: {
    properties: ['paddingTop', 'paddingBottom'],
    defaultScale: defaults.space,
  },
};

const mappedPaddingPropertiesShortcuts = {
  p: paddingMappedProperties.padding,
  pt: paddingMappedProperties.paddingTop,
  pr: paddingMappedProperties.paddingRight,
  pb: paddingMappedProperties.paddingBottom,
  pl: paddingMappedProperties.paddingLeft,
  px: paddingMappedProperties.paddingX,
  py: paddingMappedProperties.paddingY,
};

export type WithPaddingProps = Partial<
  Record<keyof typeof mappedPaddingPropertiesShortcuts, StyledPropType>
>;

export const withPadding = createExtractCssFromProps(
  mappedPaddingPropertiesShortcuts,
);
